import * as CreateAccountPostOrderActionTypes from '../actionTypes/CreateAccountPostOrderActionTypes';

export const createAccountPostOrder = (payload) => ({
    type: CreateAccountPostOrderActionTypes.CREATE_ACCOUNT_POST_REQUEST,
    payload,
});

export const getAccountByEmailId = (payload) => ({
    type: CreateAccountPostOrderActionTypes.GET_ACCOUNT_BY_EMAIL,
    payload,
});

export const enrollRewardlink = (payload) => ({
    type: CreateAccountPostOrderActionTypes.ENROLL_REWARD_LINK,
    payload,
});

export default createAccountPostOrder;
